import React from "react";
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import PageHeading from "../components/pageheading";
import CallToAction from "../components/cta";
import "../styles/global.scss";

export default function About({data}) {
  return (
    <Layout>
      <div className="about">
        <PageHeading heading="About us" />

        <h2>
          Welcome to Haslam Logistics. <br/> The UK's same-day delivery specialists.
        </h2>
        <div className="block">
          <div className="text">
            <h4>Why customers love us</h4>
            <p>
              Since our founding in the beautiful rolling hills of the Home
              Counties we’ve worked with numerous clients, from global brand
              names to smaller companies and even individuals. We believe great
              service begins and ends with experienced and friendly
              professionals that pay attention to detail. We complete projects
              efficiently and on schedule, and go above and beyond to form
              lasting relationships with our clients. <br/><br/>This has all contributed
              to our ⭐⭐⭐⭐⭐ Google rating. 
            </p>
            <h4>Personal, dedicated & on time</h4>
            <p>
              With our unique & comprehensive UK wide network of professional
              couriers, we can collect anywhere in the UK and deliver just about
              anywhere too! We don't find any job too large or too small. We work with global
              brands, medium and small businesses and even individuals. Whether
              we’re working for major corporations, or a parent wanting to
              deliver some Documents to the local school, we make sure we give
              our best service..
            </p>
            
          </div>
          <div className="spacer"></div>
          <div className="img-right">
            <Img fadeIn fluid={data.vanLoading.childImageSharp.fluid}
              alt="van being loaded"/>
          </div>
        </div>

        <div className="block">
          <div className="img-left">
          <Img fadeIn fluid={data.motorway.childImageSharp.fluid}
              alt="UK motorway"/>
          </div>
          <div className="spacer"></div>

          <div className="text-r">
          <h4>Same-day delivery</h4>
            <p>
              For urgent items, We offer a fast, personal, direct courier
              service. Anything from documents, loose items, palletised cargo,
              fragile and high value goods.
            </p>
            <h4>Our UK wide network</h4>
            <p>
              Our local same-day couriers are experienced in ensuring your
              package reaches its destination on time. These are just some of the features you can expect when you work with us:</p>
              <ul>
                  <li>Vehicles are monitored
              via GPS and have on-board messaging systems.</li>
              <li>Live traffic
              updates and route guidance is provided to all drivers to reduce
              any chances of being stuck in traffic.</li>
              <li>Digital proof of delivery
              as standard protocol.</li>
              </ul>
        
          </div>
        </div>

        <div className="block">
          <div className="text">
            <h4>Security and safety is our top priority</h4>
            <p>
              We’ve worked hard to ensure that we can cover the entire UK for 60
              minute collections and same-day deliveries. Year round staff
              training ensures we deliver the best service possible to all of
              our customers. The safety and security of your consignments is a
              non-negotiable for us, and train all of our staff to maintain the
              highest standards possible. We provide UK Wide logistic solutions
              to logistic problems and pride ourselves on doing so.
            </p>
            <p>
              No matter whether it’s the north, east, south, or west of the UK,
              we’ll get it done.
            </p>
            <br/><br/>
        
          </div>
          <div className="spacer"></div>

          <div className="img-right">
          <Img fadeIn fluid={data.parcelChecking.childImageSharp.fluid}
              alt="man checking parcels"/>
          </div>
        </div>
        <div className="ctas">
        <CallToAction to="/quote_request" text="Request Quote" />
        <CallToAction to="/contact" text="Contact Us" />
        </div>

        <Link to="/" className='backtohome'>Back to the Home Page</Link>
      </div>
    </Layout>
  );
}

export const query = graphql`
query {
    vanLoading: file(relativePath: {eq: "Van being loaded.jpg"}) {
      childImageSharp {
        fluid (maxWidth: 800){
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  
  
 
    motorway: file(relativePath: {eq: "UK Motorway.jpg"}) {
      childImageSharp {
        fluid (maxWidth: 800){
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  
  

    parcelChecking: file(relativePath: {eq: "Man checking parcel.jpg"}) {
      childImageSharp {
        fluid (maxWidth: 800){
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  
} 
`